import { Date } from "./Date";
export var DateRange;
(function (DateRange) {
    function is(value) {
        return typeof value == "object" && Date.is(value.start) && Date.is(value.end);
    }
    DateRange.is = is;
    function create(start, end) {
        return !Date.is(end)
            ? create(start, Date.next(start, end))
            : start <= end
                ? { start, end }
                : { start: end, end: start };
    }
    DateRange.create = create;
    function toDates(value, includeLast = true) {
        const result = [];
        for (let current = value.start; includeLast ? current <= value.end : current < value.end; current = Date.next(current))
            result.push(current);
        return result;
    }
    DateRange.toDates = toDates;
    function getDays(value) {
        const result = value.start <= value.end
            ? Math.ceil((new globalThis.Date(value.end).getTime() - new globalThis.Date(value.start).getTime()) / (1000 * 3600 * 24))
            : -getDays({ start: value.end, end: value.start });
        return result;
    }
    DateRange.getDays = getDays;
})(DateRange || (DateRange = {}));
//# sourceMappingURL=DateRange.js.map